export enum DeviceType {
  Android = 'android',
  IOS = 'ios',
  Web = 'web',
}

export enum AppContext {
  Cwv = 'cwv',
}
